import { Tabs } from "@material-ui/core";
import { observer } from "mobx-react";
import * as React from "react";
import { useLocation } from "react-router";
import { NAVBAR_HEIGHT } from "../../config";
import { t } from "../../i18n/util";
import { THEME } from "../../theme/ThemeStore";
import { pushRoute } from "../app/router/history";
import { useMobileMediaQuery } from "../hooks/useMobileMediaQuery";
import { useScrollBlock } from "../hooks/useScrollBlock";
import { DarkModeToggle } from "../ui/DarkModeToggle";
import { NotificationsElement } from "../ui/NotificationsElement";
import { Burger, ImageLogo } from "../ui/Primitives";
import { BurgerMenu, BurgerMenuElement, NavBarTab, NavBarUserElement } from "./HrNavBarElements";
import { HrRoutes } from "./router/HrRoutes";

export const HrNavBar = observer(() => {
    const { pathname } = useLocation();
    const [value, setValue] = React.useState<"dashboard" | "evidence" | "rejected" | false>(false);
    const isMobile = useMobileMediaQuery();
    const [open, setOpen] = React.useState(false);

    const [blockScroll, allowScroll] = useScrollBlock();

    const borderBottomStyle =
        THEME.THEME_NAME === "aaa" ? `1px solid ${open ? "transparent" : THEME.customColors.borderColor}` : undefined;

    React.useEffect(() => {
        if (pathname === HrRoutes.DASHBOARD) {
            setValue("dashboard");
        } else if (pathname === HrRoutes.EVIDENCE) {
            setValue("evidence");
        } else if (pathname === HrRoutes.REJECTED) {
            setValue("rejected");
        } else {
            setValue(false);
        }
    }, [pathname]);

    // blocks scroll when mobile menu is opened
    React.useEffect(() => {
        if (isMobile && open) {
            blockScroll();
        } else {
            allowScroll();
        }
    }, [allowScroll, blockScroll, isMobile, open]);

    return isMobile ? (
        <>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: borderBottomStyle,
                    padding: 22,
                    zIndex: 10,
                    backgroundColor: THEME.customColors.darkPrimary
                }}
            >
                <ImageLogo
                    style={{
                        maxHeight: "100%",
                        maxWidth: "35%"
                    }}
                />
                <div style={{ display: "flex", gap: 24 }}>
                    <NotificationsElement />
                    <Burger open={open} setOpen={setOpen} />
                </div>
            </div>

            <BurgerMenu open={open}>
                <BurgerMenuElement
                    onClick={() => pushRoute(HrRoutes.DASHBOARD)}
                    setOpen={setOpen}
                    label={"screen.dashboard"}
                    highlighted={value === "dashboard"}
                />
                <BurgerMenuElement
                    onClick={() => pushRoute(HrRoutes.EVIDENCE)}
                    setOpen={setOpen}
                    label={"screen.dashboard.evidence"}
                    highlighted={value === "evidence"}
                />
                <BurgerMenuElement
                    onClick={() => pushRoute(HrRoutes.REJECTED)}
                    setOpen={setOpen}
                    label={"screen.rejected"}
                    highlighted={value === "rejected"}
                />
                <DarkModeToggle />
                <NavBarUserElement />
            </BurgerMenu>
        </>
    ) : (
        <>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: borderBottomStyle,
                    padding: "0 42px 0 12px",
                    height: NAVBAR_HEIGHT
                }}
            >
                <div style={{ display: "flex", alignItems: "center" }}>
                    <ImageLogo
                        onClick={() => {
                            pushRoute(HrRoutes.DASHBOARD);
                        }}
                        style={{
                            maxHeight: "100%",
                            maxWidth: "35%",
                            padding: 22,
                            marginRight: 48,
                            cursor: "pointer"
                        }}
                    />
                    <Tabs
                        value={value}
                        indicatorColor="primary"
                        TabIndicatorProps={{ style: { height: 3 } }}
                        style={{ height: "100%", minWidth: "100%" }}
                    >
                        <NavBarTab
                            value="dashboard"
                            label={t("screen.dashboard")}
                            onClick={() => pushRoute(HrRoutes.DASHBOARD)}
                        />
                        <NavBarTab
                            value="evidence"
                            label={t("screen.dashboard.evidence")}
                            onClick={() => pushRoute(HrRoutes.EVIDENCE)}
                        />
                        <NavBarTab
                            value="rejected"
                            label={t("screen.rejected")}
                            onClick={() => pushRoute(HrRoutes.REJECTED)}
                        />
                    </Tabs>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 48 }}>
                    <DarkModeToggle />
                    <NotificationsElement />
                    <NavBarUserElement />
                </div>
            </div>
        </>
    );
});
